export default (title, headers, data) => {
  let csv = `${headers.join(',')}\n`;

  data.forEach((row) => {
    csv += row.map(item => (item ? `"${item}"` : '')).join(',');
    csv += '\n';
  });

  const hiddenElement = document.createElement('a');
  hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = `${title}_${new Date().getTime()}.csv`;
  hiddenElement.click();

  return csv;
};
